import { Component, OnInit } from '@angular/core';
import { ConsigneeDetails } from 'src/app/Models/ops';

@Component({
  selector: 'app-spra-view-consignee',
  templateUrl: './spra-view-consignee.component.html',
  styleUrls: ['./spra-view-consignee.component.css']
})
export class SpraViewConsigneeComponent implements OnInit {
  public ConsineeDetails: Array<ConsigneeDetails>;
  
  constructor() {
 
  this.ConsineeDetails = new Array<ConsigneeDetails>();
   }

  ngOnInit(): void {
  }

}
